/**
 * Store Auth
 */
export default {
    state: {
        checked: document.querySelector('meta[name="auth"]').getAttribute('content') === '1',
        user: null,
        rights: {
            read: 1,
            update: 2,
            create: 4,
            delete: 8,
            exec: 16,
        }
    },

    mutations: {
        /**
         * Authentifie l'utilisateur sur l'application front
         */
        saveLogin: function (state) {
            state.checked = true
        },

        /**
         * Déconnecte l'utilisateur sur l'application front
         */
        saveLogout: function (state) {
            state.checked = false
            state.user = null
        },

        /**
         * Initialise le state user
         */
        setUser: function (state, user) {
            state.user = user
        }
    },

    actions: {
        /**
         * Initialise le state user
         */
        init: function (context) {
            return axios.get('/api/users/auth').then(response => {
                context.commit('setUser', response.data.data)
            })
        }
    },

    getters : {
        me: state => state.user,
        /**
         * Permet de savoir si l'utilisateur a une permission
         */
        can: state => (type, slug) => {
            try {
                let keys = type.split('-')
                return (state.user.permissions[keys[1]][slug] & state.rights[keys[0]]) !== 0
            } catch (e) {
                return false
            }
        }
    }
}
